<template>
  <div class="cart">
    <el-dialog
      data-test="modal"
      title="Confirmation"
      :visible.sync="dialogVisible"
      width="30%"
      class="cart--modal"
      :modal-append-to-body="false">
      <span>{{$t('cart.deleteProduct')}}</span>
      <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">{{$t('cart.abort')}}</el-button>
                        <el-button type="primary"
                                   @click="deleteAllProducts($event)">
          {{$t('cart.confirm')}}
            </el-button>
          </span>
    </el-dialog>
    <el-card class="box-card">
      <div slot="header" class="cart--header">
        <h1>{{$t('cart.cart')}}</h1>
        <el-button style="" type="danger"
                   plain
                   v-on:click="dialogVisible = true"
                   :disabled="shouldEmptyCartBeDisabled"
                   data-test="empty-cart">{{$t('cart.emptyCart')}}
        </el-button>
      </div>
      <el-card v-for="supplier in cartBySupplierToProcess" v-bind:key="supplier.key"
               class="box-card supplier-card"
               :style="'background-color:' + getSupplierBgColor(supplier.key)">
        <div slot="header" class="clearfix supplier-card--header">
          <div> {{supplier.key}}
          </div>

          <DatePicker v-if="shouldDisplayDate(supplier.key)"
                      class="supplier-card--header--date"
                      :supplier="supplier.key"
                      @emitDate="bubbleUpDate($event, supplier.key)"/>
        </div>
        <el-alert v-if="getHours(supplier.key) && getHours(supplier.key).length"
                  title=""
                  type="info"
                  show-icon
                  class="supplier-card--info">
          <h3> Les créneaux de commande pour {{supplier.key}} sont les suivants: </h3>
          <ul v-for="(hour, index) in getHours(supplier.key)" v-bind:key="index">
            <li class="supplier-card--info--li">{{hour}}</li>
          </ul>
          <h2> Si vous commandez en dehors de ces créneaux,
            votre commande sera traitée à la période suivante. </h2>
        </el-alert>
        <el-row v-for="product in supplier.value" v-bind:key="product.id">
          <Product :product="product"
                   :is-cart="true"
                   :num="num"
                   @deleteOneProduct="emitProductToDelete($event)"></Product>
        </el-row>
        <el-button @click="bubbleUpSpecificSupplier(supplier)"
                   class="supplier-card--validate"
                   type="success"
                   plain
                   round>Envoyer la commande
        </el-button>
        <el-dialog
          title="Demande de confirmation"
          :visible.sync="confirmSend"
          width="30%"
          :before-close="handleClose">
          <el-alert
            title="Attention"
            type="warning">
            <h4>Vous avez déjà effectué une commande à: {{lastOrderDate}}.</h4>
            <h4>Êtes-vous sûr de vouloir passer une nouvelle commande?</h4>
          </el-alert>
          <el-alert
            title="Vous avez oublié des produits dans votre commande précédente?"
            type="warning"
            class="forgot--product">
            <h4><u>Dans ce cas, contactez votre fournisseur par
              téléphone pour compléter votre commande.</u></h4>
          </el-alert>

          <span slot="footer" class="dialog-footer">
    <el-button @click="confirmSend = false">annuler</el-button>
    <el-button type="primary" @click="bubbleUpSpecificSupplier(supplier)">
      J'envoie ma commande</el-button>
  </span>
        </el-dialog>
      </el-card>
    </el-card>
  </div>
</template>

<script>
  import services from 'services';
  import DatePicker from '../DatePicker/DatePicker.vue';
  import { basicUtils, cssUtils } from '../../utils/utils';
  import { cartValidator } from './cartValidator';
  import Product from '../Product/Product.vue';

  export default {
    data() {
      return {
        lastOrderDate: '',
        confirmSend: false,
        label: {
          supplier: 'backeurop',
        },
        dialogVisible: false,
      };
    },
    props: {
      shopId: null,
      cart: {},
      suppliers: {},
      num: undefined,
    },
    components: {
      Product,
      DatePicker,
    },
    computed: {
      shouldEmptyCartBeDisabled() {
        return !this.cartBySupplierToProcess.length;
      },
      cartBySupplierToProcess() {
        return services.CartService.cartBySupplierToArray(this.cart);
      },

      getHours() {
        return (supplier) => services.CartService.getSupplierHours(supplier);
      },
      shouldDisplayDate() {
        return (supplier) => services.CartService.getSupplierDisplayDate(supplier);
      },
    },
    methods: {
      async getLastOrderDate(shopId, supplier) {
        // eslint-disable-next-line max-len
        const date = await services.CartService.getLastOrderTimeBySupplier(shopId, supplier);
        this.lastOrderDate = basicUtils.timeFromATs(date);
      },
      handleClose() {
        this.confirmSend = false;
      },
      bubbleUpDate(date, supplier) {
        this.$emit('bubbleUpDate', {
          date: basicUtils.givenDate(date),
          supplier,
        });
      },

      async bubbleUpSpecificSupplier(supplier) {
        if (this.confirmSend) {
          this.$emit('bubbleUpSupplier', supplier);
          this.confirmSend = false;
          return;
        }
        if (!(await services.CartService.checkLastOrder(this.shopId, supplier.key))) {
          await this.getLastOrderDate(this.shopId, supplier.key);
          // eslint-disable-next-line max-len
          this.confirmSend = !(await services.CartService.checkLastOrder(this.shopId, supplier.key));
          return;
        }
        if (cartValidator.specificCartQuantityCheck(supplier.value) !== undefined) {
          this.noQuantityForAProduct();
          return;
        }
        this.$emit('bubbleUpSupplier', supplier);
      },
      emitProductToDelete(product) {
        this.$emit('deleteOneProduct', product);
      },
      deleteAllProducts() {
        this.dialogVisible = false;
        this.$emit('removeAllProducts');
      },
      getSupplierBgColor(supplier) {
        return cssUtils.supplierBackgroundColor(supplier);
      },
      noQuantityForAProduct() {
        this.$message.error({
          type: 'error',
          message: 'Un produit ne possède pas de quantité',
        });
      },
    },
  };
</script>

<style lang="stylus">
  @import '~@/assets/css/main.styl';
  .box-card {
    margin 20px auto
    width 95%
  }

  .supplier-card--info {
    display flex
    margin-bottom 10px
    margin-left auto
    margin-right auto
  }

  .supplier-card--info--li {
    font-size large
  }

  .cart--header
    display flex
    flex-direction row
    justify-content space-between
    align-items center

  .supplier-card
    margin 20px

  .supplier-card--header
    display flex
    flex-direction row
    justify-content space-between
    align-items center

  .cart--modal
    z-index 555555

  .container
    margin-bottom 10px

  .supplier-card--validate
    display flex
    flex-direction row

  @media screen and (max-width: 1300px)
    .box-card
      width 90%

    @media screen and (max-width: 600px)
      .box-card
        width 90%

      .supplier-card
        margin 20px
        justify-content center

      .supplier-card--header
        margin 0
        display flex
        flex-direction column
        justify-content space-between
        align-content left
        align-items left

      .supplier-card--header--date
        margin-top 10px

      .cart--header
        display flex
        flex-direction column

  .forgot--product {
    margin-top 10px
    word-break: normal;
  }
</style>
